import { Resolver, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';

import { InvoiceVerificationDTO } from 'support/types';

import { invoiceVerificationDetailsSchema } from '../schema';

/**
 * Custom hook for managing invoice verification form validation
 * Handles form setup, validation, and error processing
 */
export const useInvoiceValidation = (payload: InvoiceVerificationDTO['payload']) => {
  const formMethods = useForm({
    values: payload,
    resolver: yupResolver(invoiceVerificationDetailsSchema) as Resolver<Required<InvoiceVerificationDTO>['payload']>,
  });

  return {
    formMethods,
  };
};
